const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const ImpositionEarlyCancel = require('components/imposition/impositionEarlyCancel/impositionEarlyCancel');
// @actions
const impositionEarlyCancellation = require('actions/contactCenter/impositionEarlyCancellation');
const depositsActions = require('actions/deposits');

class ImpositionEarlyCancelContainer extends React.Component {
    render() {
        return <ImpositionEarlyCancel {...this.props} />;
    }
}

ImpositionEarlyCancelContainer.propTypes = {
    immProfile: PropTypes.object.isRequired,
    immImpositionEarlyCancellationData: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    queryImpositionEarlyCancellationData: PropTypes.func.isRequired,
    earlyCancelImposition: PropTypes.func,
    requestDeposits: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    immProfile: state.profile,
    immImpositionEarlyCancellationData: state.impositionEarlyCancellation,
    immDeposits: state.deposits,
    immAccounts: state.accounts,
});

module.exports.constructor = ImpositionEarlyCancelContainer;
module.exports.ImpositionEarlyCancelContainer = connect(
    mapStateToProps,
    {
        requestDeposits: depositsActions.requestDeposits,
        requestInterveners: depositsActions.requestDepositInterveners,
        queryImpositionEarlyCancellationData: impositionEarlyCancellation.queryImpositionEarlyCancellationData,
        earlyCancelImposition: impositionEarlyCancellation.earlyCancelImposition,
        setVisibleStep: impositionEarlyCancellation.setVisibleStep,
        validateStep: impositionEarlyCancellation.validateStep,
        showCancelModal: impositionEarlyCancellation.showCancelModal,
    }
)(ImpositionEarlyCancelContainer);
